import Compressor from "compressorjs";

const MaxAllowedSize = 2.5 * 1024 * 1024; // 4MB

export const CompressImage = (file) => {
  return new Promise((resolve, reject) => {
    const qualityNum = file.size > MaxAllowedSize ? 0.7 : 1;
    new Compressor(file, {
      quality: qualityNum,
      convertTypes: ['image/png', 'image/webp', 'image/jpeg'],
      convertSize: 5 * 1024 * 1024,
      success(result) {
        resolve({ fileName: file.name, file: result, url: URL.createObjectURL(result) });
      },
      error(err) {
        reject(err);
      },
    });
  });
};
